///
/// EarthBrowser Admin Dashboard - User Slice
///
/// Created: 2025-11-27
/// Copyright (c) 2025 Geodata Labs
///

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface UserProfile {
  id: number
  email: string
  first_name: string
  last_name: string
  avatar_url?: string
}

interface UserState {
  userProfile?: UserProfile
  isAdmin: boolean
  permissions: string[]
}

const initialState: UserState = {
  userProfile: undefined,
  isAdmin: false,
  permissions: [],
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile | undefined>) => {
      state.userProfile = action.payload
    },
    setIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload
      state.isAdmin = action.payload.includes('admin.access')
    },
    clearUser: (state) => {
      state.userProfile = undefined
      state.isAdmin = false
      state.permissions = []
    },
  },
})

export const { setUserProfile, setIsAdmin, setPermissions, clearUser } = userSlice.actions

